"use client";

import useRtl from "@/hooks/useRtl";
import useDarkMode from "@/hooks/useDarkMode";
import useSkin from "@/hooks/useSkin";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import useAuthInfo from "@/store/auth";
import { usePathname } from 'next/navigation'

export default function AuthLayout({ children }) {
  const [isRtl] = useRtl();
  const [isDark] = useDarkMode();
  const [skin] = useSkin();
  const [isHydrated, setIsHydrated] = useState(false)
  const router = useRouter();
  const userData = useAuthInfo((state) => state);
  const pathname = usePathname()

  useEffect(() => {
    if (userData.apiToken && isHydrated && !pathname.includes("forgot-password")) {
      setTimeout(() => {
        router.push("/");
      }, 200);
    }
  }, [userData]);

  useEffect(() => {
    HydratePage();
  }, []);

  const HydratePage = async () => {
    await useAuthInfo.persist.rehydrate();
    setIsHydrated(true)
  };

  return (
    <>
      <div
        dir={isRtl ? "rtl" : "ltr"}
        className={`app-warp ${isDark ? "dark" : "light"} ${
          skin === "bordered" ? "skin--bordered" : "skin--default"
        }`}
      >
        <ToastContainer />
        {children}
      </div>
    </>
  );
}
